module.exports = __webpack_public_path__ + "img/JOC_3071.e0700d98.jpg";